module.exports = __webpack_public_path__ + "static/media/Akkurat-Light.bc9fa02b.ttf";